/**
  @module @ember-data/store
*/
export default class ImplicitRelationship {
  constructor(graph, definition, identifier) {
    this.graph = graph;
    this.definition = definition;
    this.identifier = identifier;
    this.members = new Set();
    this.canonicalMembers = new Set();
  }
  addCanonicalRecordData(recordData, idx) {
    if (!this.canonicalMembers.has(recordData)) {
      this.canonicalMembers.add(recordData);
      this.members.add(recordData);
    }
  }
  addRecordData(recordData, idx) {
    if (!this.members.has(recordData)) {
      this.members.add(recordData);
    }
  }
  removeRecordData(recordData) {
    if (recordData && this.members.has(recordData)) {
      this.members.delete(recordData);
    }
  }
  removeCompletelyFromOwn(recordData) {
    this.canonicalMembers.delete(recordData);
    this.members.delete(recordData);
  }
  clear() {
    this.canonicalMembers.clear();
    this.members.clear();
  }
}